import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { UserProfileReviewsFilterRedesignComponent } from './user-profile-reviews-filter-redesign.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    PipesModule,
    TrackingModule,
    UiModule,
  ],
  declarations: [UserProfileReviewsFilterRedesignComponent],
  exports: [UserProfileReviewsFilterRedesignComponent],
})
export class UserProfileReviewsFilterRedesignModule {}
